// Convertir une date de yyyy-MM-dd en dd-MM-yyyy
export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = String(dateString).split("-");
  if (!year || !month || !day) return "";
  return `${day}-${month}-${year}`;
};

// Convertir une date de dd-MM-yyyy en yyyy-MM-dd
export const convertToYYYYMMDD = (dateString) => {
  if (!dateString) return "";
  const [day, month, year] = String(dateString).split("-");
  if (!day || !month || !year) return "";
  return `${year}-${month}-${day}`;
};

export const formatUTCDateToDDMMYYYY = (date) => {
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
};

export const parseDDMMYYYY = (dateString) => {
  if (!dateString) return null;
  const [day, month, year] = String(dateString).split("-").map(Number);
  if (!day || !month || !year) return null;
  return new Date(Date.UTC(year, month - 1, day));
};

export const getCurrentMonthPeriod = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return {
    startDate: formatDate(firstDay),
    endDate: formatDate(lastDay),
  };
};

export const getMonthPeriodFromDate = (dateString) => {
  const baseDate = parseDDMMYYYY(dateString);
  if (!baseDate) return { startDate: "", endDate: "" };

  const year = baseDate.getUTCFullYear();
  const month = baseDate.getUTCMonth();

  return {
    startDate: formatUTCDateToDDMMYYYY(new Date(Date.UTC(year, month, 1))),
    endDate: formatUTCDateToDDMMYYYY(new Date(Date.UTC(year, month + 1, 0))),
  };
};

export const getPreviousMonthPeriod = () => {
  const now = new Date();

  return {
    startDate: formatUTCDateToDDMMYYYY(
      new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1))
    ),
    endDate: formatUTCDateToDDMMYYYY(
      new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 0))
    ),
  };
};

export const getCurrentDateYYYYMMDD = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};